import { Schema } from 'normalizr';

export const tileSchema = new Schema('tile', { idAttribute: 'id' });
